import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ResetPasswordIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9271 10.0026C17.9271 11.5684 17.4628 13.099 16.5929 14.4009C15.723 15.7028 14.4866 16.7175 13.04 17.3167C11.5934 17.9158 10.0016 18.0726 8.46595 17.7672C6.93027 17.4617 5.51966 16.7077 4.41249 15.6005C3.30533 14.4934 2.55134 13.0828 2.24587 11.5471C1.9404 10.0114 2.09718 8.41961 2.69637 6.97303C3.29557 5.52645 4.31027 4.29003 5.61216 3.42014C6.91404 2.55024 8.44465 2.08594 10.0104 2.08594C11.5513 2.08543 13.0588 2.53459 14.3481 3.37834C15.6374 4.22208 16.6524 5.42373 17.2688 6.83594M17.9271 4.58594L17.5313 7.23177L15.0104 6.66927"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.34375 9.16667V7.91667C8.34375 7.47464 8.51935 7.05072 8.83191 6.73816C9.14447 6.4256 9.56839 6.25 10.0104 6.25C10.4524 6.25 10.8764 6.4256 11.1889 6.73816C11.5015 7.05072 11.6771 7.47464 11.6771 7.91667V9.16667M9.38542 13.75H10.6354C11.6129 13.75 12.1021 13.75 12.4379 13.4917C12.5246 13.4251 12.6022 13.3475 12.6687 13.2608C12.9271 12.9242 12.9271 12.4358 12.9271 11.4583C12.9271 10.4808 12.9271 9.99167 12.6687 9.65583C12.6022 9.56913 12.5246 9.49152 12.4379 9.425C12.1012 9.16667 11.6129 9.16667 10.6354 9.16667H9.38542C8.40792 9.16667 7.91875 9.16667 7.58292 9.425C7.49621 9.49152 7.41861 9.56913 7.35208 9.65583C7.09375 9.9925 7.09375 10.4808 7.09375 11.4583C7.09375 12.4358 7.09375 12.925 7.35208 13.2608C7.41861 13.3475 7.49621 13.4251 7.58292 13.4917C7.91958 13.75 8.40792 13.75 9.38542 13.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

ResetPasswordIcon.displayName = 'ResetPasswordIcon';
